import type { ClientConfig, CreateMeetingRequest, CreateMeetingResponse, MeetingPublicInfo } from '../../shared/protocol';
import { getClientId } from './storage';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, { ...init, headers: { 'Content-Type': 'application/json', ...init?.headers } });
  } catch {
    throw new ApiError('No se puede conectar con el servidor. Comprueba tu conexión.', 0);
  }
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(body.error ?? `Error ${res.status}`, res.status);
  return body as T;
}

let publicBase: string | null = null;

/** Fetches /api/config and remembers the address other people should use for invitations. */
export async function loadClientConfig(): Promise<ClientConfig> {
  const config = await request<ClientConfig>(`/api/config?clientId=${encodeURIComponent(getClientId())}`);
  publicBase = config.publicUrl;
  return config;
}

/** Address others can open (LAN IP, tunnel or domain); falls back to the current origin. */
export function shareBase(): string {
  return publicBase ?? location.origin;
}

export const api = {
  config: loadClientConfig,
  createMeeting: (req: CreateMeetingRequest) => request<CreateMeetingResponse>('/api/meetings', { method: 'POST', body: JSON.stringify(req) }),
  getMeeting: (id: string) => request<MeetingPublicInfo>(`/api/meetings/${id}`),
  deleteMeeting: (id: string, hostKey: string) => request<{ ok: true }>(`/api/meetings/${id}`, { method: 'DELETE', headers: { 'X-Host-Key': hostKey } }),
};

export function joinUrl(id: string, passcode: string | null): string {
  const url = new URL(`/j/${id}`, shareBase());
  if (passcode) url.searchParams.set('pwd', passcode);
  return url.toString();
}
